document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".product-price--tax").forEach(function(el) {
    const text = el.textContent.trim();
    const i = text.indexOf(",");
    if (i === -1) return;

    const before = text.slice(0, i + 1);      // inkl. Komma
    const after  = text.slice(i + 1).trim();  // nach Komma

    el.innerHTML = before + 
      ' <a href="https://koesmetik.de/pages/versand-und-zahlungsbedingungen"><u>' 
      + after + '</u></a>';
  });
});
